export default "/assets/svg/invitation.svg"